import { post } from "@src/appV2/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, UseMutationOptions, type UseMutationResult } from "@tanstack/react-query";
import { z } from "zod";

export function useResyncPaymentStatusWithStripe(
  options?: UseMutationOptions<void, unknown, { workerId: string }>
): UseMutationResult<void, unknown, { workerId: string }> {
  return useMutation({
    mutationKey: ["resync-payment-status-with-stripe"],
    mutationFn: async ({ workerId }) => {
      const url = `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${workerId}/resync-from-stripe`;
      const response = await post({
        url,
        responseSchema: z.any(),
      });
      return response.data;
    },
    retry: false,
    meta: { logErrorMessage: APP_V2_APP_EVENTS.RESYNC_PAYMENT_STATUS_WITH_STRIPE_FAILURE },
    ...options,
  });
}
